import { render, staticRenderFns } from "./ThreeColumnLayout.vue?vue&type=template&id=2cbe9f66"
import script from "./ThreeColumnLayout.vue?vue&type=script&lang=js"
export * from "./ThreeColumnLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports